import { render, staticRenderFns } from "./ServicesInMerchantManage.vue?vue&type=template&id=f8b2cb60&"
import script from "./ServicesInMerchantManage.vue?vue&type=script&lang=js&"
export * from "./ServicesInMerchantManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports